<template>
  <div id="notFound">
    <img src="/static/img/logo.png" class="center-block logo">

    <div class="text-center col-sm-12">
      <h1>Você está perdido?</h1>
      <h4>Essa página não existe.</h4>
      <router-link to="/" class="vertical-5p lead">Leve-me para a principal.</router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NotFound'
}
</script>

<style>
#notFound {
  padding: 10em;
  color: white;
}
</style>



// WEBPACK FOOTER //
// 404.vue?0aa8e26c